import { Component, OnInit, OnDestroy} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { HomeService } from '../../../pages/home/services/home.service';
import { EmployeeService } from './../../../pages/employee/services/employee.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EventService } from '../../services/event.service';
import { ClockinJobModalComponent } from 'src/app/modals/home/clockin-job-modal/clockin-job-modal.component';
import { ErrorModalComponent } from 'src/app/modals/shared/error-modal/error-modal.component'
import { ClockoutModalComponent } from 'src/app/modals/home/clockout-modal/clockout-modal.component'
import { PaperlessModalComponent } from 'src/app/modals/home/paperless-modal/paperless-modal.component'
import { PasswordWarningModalComponent } from 'src/app/modals/home/password-warning-modal/password-warning-modal.component'
import { WarningModalComponent } from '../../../modals/shared/warning-modal/warning-modal.component';
import { AlertModalComponent } from '../../../modals/shared/alert-modal/alert-modal.component';
import { OrderByPipe } from './../../../shared/pipe/order-by.pipe';
import moment from 'moment';
import { HttpClient, HttpRequest, HttpEvent, HttpEventType } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { ConfirmationModalComponent } from 'src/app/modals/home/confirmation-modal/confirmation-modal.component';
import { UtilityService } from '../../services/utility.service';
import { PortalModulesService } from '../../services/portal-modules.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.css']
})

export class NavigationComponent implements OnInit, OnDestroy {
  pRCO: number;
  loginMode: string;
  isOver: boolean;
  portalSettings: any;
  portalModules: any;
  employeeInfo: any;
  formData: { [key: string]: any } = {};
  requestObj: { [key: string]: any } = {};
  modules: any;
  menu: any[] = [];
  format: string;
  position: any;
  clockStatus: { [key: string]: any } = {};
  showTeamLinkOnNav: boolean;
  viewpointOneUrl: string;
  ViewpointAnalyticsURL: string;
  hotlistMenu: boolean;
  userNameMenu: boolean;
  teamMenu: boolean;
  unapprovedRequestCount: number;
  moduleCategories: any[];
  hotlistItems: any[] = [];
  moduleCategoriesMobile: any[];
  navBarClockInEnabled: boolean;
  requestingLocation: boolean = true;
  geolocationEnabled: boolean;
  performingClockAction: boolean;
  siteUrl: string;
  languagePack: boolean;
  clockInUsePhase: boolean;
  showPaperless: boolean;
  newFiles: any[] = [];
  isSafari: boolean = false;
  isMobileIos: any;
  currencySymbol: string;
  image: any = null;
  showImageNow: boolean;
  submitCount: number;
  apInvoiceShow: boolean;
  apEnabled: boolean;
  helpLink: string;
  feedbackEmail: string;
  fieldToolsCount: number;
  expenseReport: string = '/Employee/ExpenseReport'
  isExpensePage: boolean = window.location.pathname.indexOf(this.expenseReport.toLowerCase()) != -1;
  unapprovedPersonalInfoRoute: string = "/Admin/PersonalInfoRequests";
  unapprovedTimeRoute: string = "/Approval/Index";
  jobApprovalRoute: string = "/Approval/JobApproval";
  fieldToolsIssues: string = "/IssueTracker/Index";
  timeOffDashboard: string = "/Approval/ManageTimeOff";
  progressApprove: string = "/Field/ProgressEntryApproval";
  benefitRequest: string = "/Approval/BenefitsRequests";
  dependentRequest: string = "/Approval/DependentRequests";
  jobBillingReview: string = "/Billing/BillingReview"
  userAccess: string = "/Admin/ManageEmployees";
  printHuddle: string = "/Field/PrintHuddle";
  newReceiptID: any;
  newReceiptItemID: any;
  upload: any;
  fileData: any[];
  innerCounter: number;
  openModalLeft: number;
  isModuleAdmin: boolean;
  suggestionUrl: string = "https://keystyle.ideas.aha.io/ideas";
  errorMsg: string;
  portalName: string;
  logoUrl: string;
  orderByPipe: any;
  hideBar: boolean = window.location.pathname.includes(this.printHuddle.toLowerCase());
  showOfficeRoute: boolean;
  addAttachmentToReceipt: boolean = false;
  navBarNavigationEnd$: any;
  approvalCounts: { [key: string]: number } = {};
  payLink: any;
  pRCompaniesToIncludeForPayLinkList: any;
  isTrimblePayUser: boolean = false;
  private readonly approvalCountRefreshInterval: number = 60 * 1000;
  private subscriptions: Subscription[] = [];

  constructor(private router: Router,
    portalSettingsService: PortalSettingsService,
    employeeInfoService: EmployeeInfoService,
    private homeService: HomeService,
    private employeeService: EmployeeService,
    private modalService: BsModalService,
    private ngbModalService: NgbModal,
    public HttpClient: HttpClient,
    private eventService: EventService,
    private utilityService: UtilityService,
    private portalModulesService: PortalModulesService)
  {
    portalSettingsService.portalSettings$.subscribe(latestSettings => {
      this.portalSettings = latestSettings;
    });
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
    this.portalModules = this.portalModulesService.getPortalModules();
  }

  ngOnInit(): void {
    this.navBarNavigationEnd$ = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isExpensePage = window.location.pathname.indexOf(this.expenseReport.toLowerCase()) != -1;
        this.closeGlobalNav();
      }
    });

    this.subscriptions.push(this.eventService.onSendApprovalCountReceived((approval: string, count: number) => this.updateApprovalCount(approval, count)));
    this.init();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub?.unsubscribe());
    this.navBarNavigationEnd$.unsubscribe();
  }

  init() {
    this.initApprovalCounts();
    this.orderByPipe = new OrderByPipe();
    this.getUserContext();
    this.clockInUsePhase = this.portalSettings.ClockInUsePhase.ConfigValue == "1";
    this.showTeamLinkOnNav = this.portalSettings.ShowTeamLinkOnNav.ConfigValue == 1;
    this.navBarClockInEnabled = this.portalSettings.NavBarClockInEnabled.ConfigValue == "1";
    this.payLink = this.portalSettings.TrimblePayLink.ConfigValue;
    this.siteUrl = "kdstimecard://" + window.location.origin;

    var browserLanguage = this.utilityService.getBrowserLanguage();
    var url = browserLanguage === "en-AU" ? "https://au.team.viewpoint.com" : "https://team.viewpoint.com";
    this.viewpointOneUrl = url;
    this.ViewpointAnalyticsURL = url + "/vo/analytics/" + this.portalSettings.ViewpointOneEnterpriseID.ConfigValue + "/home";

    this.showPaperless = (this.portalSettings.ShowC1095Paperless.ConfigValue == 1 || this.portalSettings.ShowW2Paperless.ConfigValue == 1 || this.portalSettings.ShowPaystubPaperless.ConfigValue == 1 || this.portalSettings.AllowPaperlessInfoChange.ConfigValue == "1" || this.portalSettings.ShowPaperlessCarrier.ConfigValue == "1") ? true : false;
    this.addAttachmentToReceipt = this.portalSettings.EnableAddAttachmentToReceipt.ConfigValue == "1";
    if (this.employeeInfo.IsBulletinAdmin || this.employeeInfo.IsChecklistAdmin || this.employeeInfo.IsHuddleAdmin || this.employeeInfo.IsOnboardAdmin || this.employeeInfo.IsPurchasingAdmin || this.employeeInfo.IsSecurityAdmin ||
      this.employeeInfo.IsTimecardAdmin || this.employeeInfo.IsTrainingAdmin || this.employeeInfo.IsTrainingClassAdmin || this.employeeInfo.IsVacationAdmin || this.employeeInfo.IsVacationDashAdmin) {
      this.isModuleAdmin = true;
    }
    else {
      this.isModuleAdmin = false;
    }
    if (this.navBarClockInEnabled) {
      setTimeout(() => {
        this.getClockInStatus();
      }, 1000);
    }
    this.pRCompaniesToIncludeForPayLinkList = this.portalSettings.PRCompaniesToIncludeForPayLink.ConfigValue;
    if (this.pRCompaniesToIncludeForPayLinkList) {
      this.isTrimblePayUser = this.pRCompaniesToIncludeForPayLinkList
        .split(',')
        .some((val: any) => this.employeeInfo.PRCo == val);
    }

    this.openModalLeft = (window.innerWidth - 200) / 2;
    this.formData = {};
    this.fileData = [];
    this.formData.fileDrop = null;
    this.fieldToolsCount = this.employeeInfo.IssueCount;;
    this.isSafari = this.utilityService.checkSafari();
    this.isMobileIos = navigator.userAgent.match(/(iPad|iPhone|iPod touch);.*(OS 7_|OS 8_|OS 9_|OS 10_|OS 11_|OS 12_\d)/i);
    if (this.isMobileIos != null && this.isSafari) {
      $('#NavBar').addClass('mobileSafari');
    }
    this.currencySymbol = this.utilityService.getCurrencySymbol();
    this.feedbackEmail = this.portalSettings.FeedbackEmail.ConfigValue;
    this.apEnabled = this.portalSettings.EnableAPInvoiceReview.ConfigValue == "1";
    this.helpLink = this.portalSettings.HelpLink.ConfigValue;
    if (this.portalSettings.CountryDateCode.ConfigValue == "US") {
      this.format = "MM/DD/yyyy";
    } else {
      this.format = "DD/MM/yyyy";
    }
    this.getModules();
    this.subscriptions.push(this.eventService.on('modulesChanged', () => this.getModules(true)));
    this.subscriptions.push(this.eventService.on('approvedTimecardsChanged', () => this.getEmployeeInfo()))
    this.subscriptions.push(this.eventService.on('approvedBenefitMinus', () => this.subtractApprovedBenefit()));
    this.subscriptions.push(this.eventService.on('approvedDependentChanged', () => this.getEmployeeInfo()));
    this.subscriptions.push(this.eventService.on('approvedTimeoffChanged', () => this.modifyApprovedTimeOff()));
    this.subscriptions.push(this.eventService.on('productionApprovalChanged', (eventData) => this.modifyProductionApproval(eventData.data.count)));

    // this needs to be scheduled to run every 5 minutes or so, only if the user has approval modules
    if (this.portalModules.some(m => m.ApprovalType)) {
      this.homeService.getApprovalCounts();
      setInterval(() => this.homeService.getApprovalCounts(), this.approvalCountRefreshInterval);
    }
  }

  ngAfterViewInit(): void {
    if (this.employeeInfo.ShowConsentForm && this.showPaperless) {
      this.openModal();
      this.paperLessModal();
    }
  }

  onKioskClicked(event: Event, href: any) {
    this.utilityService.isLoggedOut = true;
    window.location.href = href;
  }

  private initApprovalCounts() {
    this.portalModules.forEach(module => {
      if (module.ApprovalType) {
        this.approvalCounts[module.ApprovalType] = 0;
      }
    });
  }

  // callback method when we receive a SignalR event to update an approval count
  private updateApprovalCount(approval: string, count: number) {
    this.approvalCounts[approval] = count;

    this.calculateUnapprovedRequestCount();
  }

  private calculateUnapprovedRequestCount() {
    this.unapprovedRequestCount = 0;
    this.unapprovedRequestCount += Object.values(this.approvalCounts).map(Number).reduce((acc, val) => acc + val, 0);
    this.unapprovedRequestCount += this.employeeInfo.TimecardCount
      + this.employeeInfo.PersonalInfoCount
      + this.employeeInfo.TimeOffCount
      + this.employeeInfo.ProgressApprovalCount
      + this.employeeInfo.UnapprovedBenefitRequestCount
      + this.employeeInfo.UnapprovedDependentRequestCount;
  }

  getUserContext() {
    this.homeService.getUserContext().then((response: any) => {
      this.pRCO = response.PRCo;
      this.isOver = response.IsOver;
      this.loginMode = response.LoginMode;
      if (this.employeeInfo.LoginType != "Identity" && this.employeeInfo.PasswordResetStatus != null && window.location.pathname.toLowerCase().indexOf("changeaccountpassword") == -1) {
        if ((this.portalSettings.PasswordResetSchedule.ConfigValue > 0 || this.portalSettings.RequirePasswordChangeOnAdminUpdate.ConfigValue == "1") && this.employeeInfo.PasswordResetStatus <= 0 && this.loginMode == "viewpoint") {
          this.openPasswordWarningModal();
        }
      }
      this.checkCompanyLogo();
      this.getPortalName();
    });
  }

  async getModules(refresh: boolean = false) {
    if (this.employeeInfo != null) {
      this.calculateUnapprovedRequestCount()
    }

    //Get Counts
    let response: any;
    if (refresh) {
      response = await this.homeService.getModules();
    }
    else {
      response = this.portalModules;
    }
    response.forEach(val => {
      if (val.ModuleID == 130) {
        this.showOfficeRoute = true;
      }

      //resolve lower case urls
      val.ResolvedModuleActionName = this.utilityService.parseLowerCaseUrl(val.ModuleActionName);
    });

    if (this.isTrimblePayUser && response.some((item: any) => item.ModuleName == "AP Invoice Review")) {
      const moduleNew: any = {
        ModuleID: -1
        , ModuleName: 'TrimblePay'
        , ModulePrettyTitle: 'Trimble Pay'
        , ModuleDescription: null
        , ModuleGlyphIcon: null
        , ModuleAngularIcon: 'flash_on'
        , ModuleActionName: 'TrimblePay'
        , ModuleSortSeq: 40
        , ModuleOpenNewWindow: true
        , IsHotlistItem: false
        , ModuleCatgName: 'Approval'
        , ModuleSubCatgName: 'Manager Review'
        , ModulePrettyShortName: 'Trimble Pay'
        , ModuleCatgSeq: 5
        , ModuleSubCatgID: 16
        , ModuleCatgID: 5
        , ModuleSubCatgSeq: 1
        , ModuleShowInNav: true
        , IsNewAngular: true
        , UseGlobalErrorHandler: false
        , ApprovalType: null
      };
      response.push(moduleNew);
    }

    this.modules = response;
    this.groupModules();
  }

  openPayLink(): void {
    window.open(this.payLink, '_blank');
  }

  openModal3() {
    document.getElementById('modalNav3').style.display = 'block';
    document.getElementById('modalNav3').style.left = this.openModalLeft + 'px';
    document.getElementById('fadeNav3').style.display = 'block';
  }

  closeModal3() {
    document.getElementById('modalNav3').style.display = 'none';
    document.getElementById('fadeNav3').style.display = 'none';
  }

  checkCompanyLogo() {
    this.homeService.getCompanyLogo(this.pRCO, "s").then((response) => {
      this.image = response == "" ? null : response;
      this.showImageNow = true;
      this.logoUrl = "/Company/GetLogo?co=" + this.pRCO + "&size=S";
    });
  }

  getPortalName() {
    this.homeService.getPortalName(this.pRCO).then((response) => {
      this.portalName = response == "" ? null : response;
    });
  }

  readFile(file, call) {
    var reader = new FileReader();
    reader.onload = function (e) { return call(e, file.name) };
    reader.readAsDataURL(file);
  }

  uploadFiles(val2: any): Subscription {
    val2.Filedata.upload = new HttpRequest(
      'POST',
      "/employee/AddAttachment",
      {
        receiptID: this.newReceiptID, receiptItemID: this.addAttachmentToReceipt ? null : this.newReceiptItemID, photoFileData: val2.File, photoFileType: val2.Filename
      }, {
      reportProgress: true
    })
    return this.HttpClient.request(val2.Filedata.upload).subscribe((event: HttpEvent<any>) => {
      switch (event.type) {
        case HttpEventType.UploadProgress:
          val2.Progress = Math.round(event.loaded / event.total * 100);
          if (val2.Progress == 100) {
            val2.AttchDone = true;
            this.innerCounter++;
          }
          break;
        case HttpEventType.Response:
          this.submitCount++;
          this.openExpenseModal();
          val2.Filedata.result = event.body;
      }
    },
      error => this.errorMsg = error.message
    )
  }

  openExpenseModal() {
    if (this.submitCount != null && this.newFiles != null) {
      if (this.submitCount == this.newFiles.length && this.submitCount != 0) {
        this.formData.selectedAll = false;
        this.formData.fileDrop = null;
        this.formData.selectCount = 0;
        this.closeModal3();
        let modalRef = this.ngbModalService.open(ConfirmationModalComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.data = this.upload;
        modalRef.componentInstance.selectedEmployee = this.employeeInfo
        modalRef.componentInstance.errorMsg = this.errorMsg
        modalRef.result.then((result) => {
          this.formData.selectedAll = false;
          this.formData.selectCount = 0;
        });
      }
    }
  }

  quickAdd() {
    setTimeout(() => {
      this.newReceiptID = null;
      if (this.formData.fileDrop.length > 0) {
        this.submitCount = 0;
        var hour: any = new Date().getHours();
        var APM = " AM";
        if (hour == 24) { hour = 0; APM = " PM"; }
        if (hour == 12) { APM = " PM"; }
        if (hour > 12) { hour = hour - 12; APM = " PM"; }
        if (hour < 10) { hour = "0" + hour.toString(); }
        var min: any = new Date().getMinutes();
        if (min < 10) { min = "0" + min };
        var sec: any = new Date().getSeconds();
        if (sec < 10) { sec = "0" + sec };
        var receiptID = -1
        var receiptItemID = -1;
        var expenseDateStr = moment().format("YYYY-MM-DD");
        var description = "Quick Add at " + hour + ":" + min + ":" + sec + APM
        var userKeyId = (this.formData.selectedEmployee == null ? this.employeeInfo.UserKeyID : this.formData.selectedEmployee.UserKeyID)

        this.employeeService.insertUpdateReceipt(receiptID, userKeyId, this.employeeInfo.PRCo, description, expenseDateStr).then((response: any) => {
          this.employeeService.insertUpdateReceiptItem(receiptItemID, response.newID).then((itemResponse: any) => {
            if (itemResponse.success) {
              this.openModal3();
              this.upload = response;
              this.upload.receiptItemID = itemResponse.newID;
              this.newReceiptID = response.newID;
              this.newReceiptItemID = itemResponse.newID;
              this.newFiles = [];
              this.fileData = [];

              for (var i = 0; i < this.formData.fileDrop.length; i++) {
                this.formData.fileDrop[i].nameEdit = "";
                for (var y = 0; y < this.formData.fileDrop[i].name.substr(0, this.formData.fileDrop[i].name.lastIndexOf('.') + 1).length; y++) {
                  if (this.formData.fileDrop[i].name[y] != " " && this.formData.fileDrop[i].name[y] != "&" && this.formData.fileDrop[i].name[y] != "*" && this.formData.fileDrop[i].name[y] != ":" &&
                    this.formData.fileDrop[i].name[y] != ";" && this.formData.fileDrop[i].name[y] != "|" && this.formData.fileDrop[i].name[y] != "=" && this.formData.fileDrop[i].name[y] != "," &&
                    this.formData.fileDrop[i].name[y] != "." && this.formData.fileDrop[i].name[y] != "/" && this.formData.fileDrop[i].name[y] != "\"" && this.formData.fileDrop[i].name[y] != "[" &&
                    this.formData.fileDrop[i].name[y] != "]")
                    this.formData.fileDrop[i].nameEdit += this.formData.fileDrop[i].name[y];
                }
                this.formData.fileDrop[i].nameEdit += this.formData.fileDrop[i].name.substr(this.formData.fileDrop[i].name.lastIndexOf('.'), this.formData.fileDrop[i].name.length);
              }

              for (var i = 0; i < this.formData.fileDrop.length; i++) {
                var n = 0;
                this.innerCounter = 0;
                this.readFile(this.formData.fileDrop[i], (e, filename: string) => {
                  setTimeout(() => {
                    this.fileData.push({ data: e.target.result.toString().split(","), size: e.total, name: filename });
                    if (n == (this.formData.fileDrop.length - 1)) {
                      this.fileData.forEach(val => {
                        this.formData.fileDrop.forEach(val2 => {
                          if (val2.size == val.size && val.name == val2.name) {
                            this.newFiles.push({ File: val.data[1], Filename: val2.nameEdit, Filedata: val2, Type: val.data[0].split("/")[0] });
                          }
                        });
                      });
                      if (this.formData.fileDrop && this.formData.fileDrop.length >= 1) {
                        this.newFiles.forEach(val2 => {
                          if (val2.Progress != 100 && val2.File != null) {
                            var temp = val2.Type;
                            var type = "file";
                            if (temp == "data:image")
                              type = "Photo";
                            this.uploadFiles(val2);
                          }
                        });
                      }
                    }
                    n++;
                  });
                });
              };
            }
          }).catch((error: any) => {
            this.errorMsg = error?.error?.error ?? "An error has occured.";
          });
        }).catch((error: any) => {
          this.errorMsg = error?.error?.error ?? "An error has occured.";
        });
      }
    });
  }

  openGlobalNav() {
    document.getElementById("globalSideNav").style.width = "100%";
    this.menu = [];
    this.hotlistMenu = false;
    this.userNameMenu = false;
  };

  groupModules () {
    this.moduleCategories = [];
    this.moduleCategoriesMobile = [];
    this.hotlistItems = [];

    let hotlistItems = [];
    let moduleCategories = [];
    let moduleCategoriesMobile = [];

    var temp = {}
    var temp2 = {};
    var tempMobile = [];
    var temp2Mobile = [];

    this.modules.forEach(val => {
      if (val.ModuleCatgSeq != 100) {
        if (temp.hasOwnProperty(val.ModuleCatgName) && val.ModuleCatgName != null && val.ModuleShowInNav) {
          temp[val.ModuleCatgName].push(val);
        } else if (val.ModuleCatgName != null && val.ModuleShowInNav) {
          temp[val.ModuleCatgName] = [];
          temp[val.ModuleCatgName].push(val);
        }
        var tf = false;
        if (hotlistItems.length == 0 && val.IsHotlistItem && val.ModuleShowInNav) {
          hotlistItems.push(val);
        }
        hotlistItems.forEach((val2: any, key2: any) => {
          if (val2.ModuleName == val.ModuleName) {
            tf = true;
          }
          if (key2 == (hotlistItems.length - 1) && !tf && val.IsHotlistItem && val.ModuleShowInNav) {
            hotlistItems.push(val);
          }
        });
      }
    });

    hotlistItems = this.orderByPipe.transform(hotlistItems, "ModulePrettyShortName", "asc");
    for (let key in temp) {
      var groupCount = 0;
      var managementCount = 0;
      var tempDetail = temp[key];
      tempDetail.forEach(val => {
        if (val.ModuleCatgID == 1) {
          if (temp2["My Tools"] == null)
            temp2["My Tools"] = {};
          if (temp2["Management"] == null)
            temp2["Management"] = {};
          if (val.ModuleSubCatgID == 1 || val.ModuleSubCatgID == 18 || val.ModuleSubCatgID == 33) {
            if (temp2["My Tools"].hasOwnProperty(val.ModuleSubCatgSeq + "," + val.ModuleSubCatgName)) {
              temp2["My Tools"][val.ModuleSubCatgSeq + "," + val.ModuleSubCatgName].push(val);
            } else {
              temp2["My Tools"][val.ModuleSubCatgSeq + "," + val.ModuleSubCatgName] = [];
              temp2["My Tools"][val.ModuleSubCatgSeq + "," + val.ModuleSubCatgName].push(val);
            }
          } else {
            managementCount++;
            if (temp2["Management"].hasOwnProperty(val.ModuleSubCatgSeq + "," + val.ModuleSubCatgName)) {
              temp2["Management"][val.ModuleSubCatgSeq + "," + val.ModuleSubCatgName].push(val);
            } else {
              temp2["Management"][val.ModuleSubCatgSeq + "," + val.ModuleSubCatgName] = [];
              temp2["Management"][val.ModuleSubCatgSeq + "," + val.ModuleSubCatgName].push(val);
              groupCount++;
            }
          }
          if (managementCount == 0) {
            delete temp2["Management"];
          }
        } else {
          if (temp2.hasOwnProperty(val.ModuleSubCatgSeq + "," + val.ModuleSubCatgName)) {
            temp2[val.ModuleSubCatgSeq + "," + val.ModuleSubCatgName].push(val);
          } else {
            temp2[val.ModuleSubCatgSeq + "," + val.ModuleSubCatgName] = [];
            temp2[val.ModuleSubCatgSeq + "," + val.ModuleSubCatgName].push(val);
            groupCount++;
          }
        }
      });
      var temp3 = [];
      for (let key3 in temp2) {
        temp3.push({ catName: key3, items: temp2[key3], catID: tempDetail[0].ModuleCatgID });
      }
      moduleCategories.push({ barName: key, list: temp3, catID: tempDetail[0].ModuleCatgID, groupCount: groupCount });
      temp2 = {};
    }

    // insert Office Tools category before Approval if present, otherwise at the end
    if (this.showOfficeRoute) {
      //check if Approval is on the navbar
      let insertIndex = moduleCategories.indexOf(moduleCategories.find(c => c.barName == "Approval"));
      //if Approval is not on the navbar, check for Admin
      if (insertIndex == -1) {
        insertIndex = moduleCategories.indexOf(moduleCategories.find(c => c.barName == "Admin"));
      }
      //place Office tools to the left of approval, or admin (if no approval), else place after everything else
      insertIndex = insertIndex > -1 ? insertIndex : moduleCategories.length;
      moduleCategories.splice(insertIndex, 0, { barName: "Office Tools", list: [], catID: 99, groupCount: 0 });
    }

    //group modules by category
    this.modules.forEach(module => {
      if (module.ModuleCatgSeq != 100 && module.ModuleShowInNav) {
        if (tempMobile[module.ModuleCatgSeq] == null) {
          tempMobile[module.ModuleCatgSeq] = [];
        }
        tempMobile[module.ModuleCatgSeq].push(module);
      }
    });

    //remove unused array values
    tempMobile = tempMobile.filter(function (n) { return n != undefined });
    for (let catgKey in tempMobile) {
      moduleCategoriesMobile[catgKey] = {};
      temp2Mobile[catgKey] = {};
      var category = tempMobile[catgKey];
      category.forEach(module => {
        if (moduleCategoriesMobile[catgKey].CategoryName == null) {
          moduleCategoriesMobile[catgKey].CategoryName = module.ModuleCatgName;
          moduleCategoriesMobile[catgKey].ModuleCount = 0;
        }
        var subCategory = module.ModuleSubCatgName != null ? module.ModuleSubCatgName : 0;
        if (temp2Mobile[catgKey][subCategory] == null) {
          temp2Mobile[catgKey][subCategory] = [];
        }
        temp2Mobile[catgKey][subCategory].push(module);
        moduleCategoriesMobile[catgKey].ModuleCount++;
      });
    }

    for (let catgKey in temp2Mobile) {
      moduleCategoriesMobile[catgKey].Modules = [];
      var category = temp2Mobile[catgKey];
      for (let subCatgKey in category) {
        var subCategory = category[subCatgKey];
        if (subCatgKey != "CategoryName" && subCatgKey != "ModuleCount") {
          subCategory.sort(function (a, b) {
            if (a.ModuleSortSeq < b.ModuleSortSeq)
              return -1;
            if (a.ModuleSortSeq > b.ModuleSortSeq)
              return 1;
            return 0;
          });
          subCategory.forEach(val => {
            moduleCategoriesMobile[catgKey].Modules.push(val);
          });
        }
      }
    }

    this.hotlistItems = hotlistItems;
    this.moduleCategories = moduleCategories;
    this.moduleCategoriesMobile = moduleCategoriesMobile;

    // insert Office Tools category before Approval if present, otherwise at the end
    if (this.showOfficeRoute) {
      //check if Approval is on the navbar
      let insertIndex = this.moduleCategoriesMobile.indexOf(this.moduleCategoriesMobile.find(c => c.CategoryName == "Approval"));
      //if Approval is not on the navbar, check for Admin
      if (insertIndex == -1) {
        insertIndex = this.moduleCategoriesMobile.indexOf(this.moduleCategoriesMobile.find(c => c.CategoryName == "Admin"));
      }
      //place Office tools to the left of approval, or admin (if no approval), else place after everything else
      insertIndex = insertIndex > -1 ? insertIndex : this.moduleCategoriesMobile.length;
      this.moduleCategoriesMobile.splice(insertIndex, 0, { CategoryName: "Office Tools", ModuleCount: 0, Modules: [] });
    }
  }

  openPasswordWarningModal() {
    let modalRef = this.ngbModalService.open(PasswordWarningModalComponent, { size: 'md', backdrop: 'static', keyboard: false });
  }

  paperLessModal() {
    let modalRef = this.ngbModalService.open(PaperlessModalComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.data = this.employeeInfo;
    modalRef.componentInstance.portalSettings = this.portalSettings;

    modalRef.result.then((result) => {
      this.homeService.getEmployeeInfo().then((response: any[]) => {
        this.employeeInfo = response;
      });
      this.closeModal();
    });
  }

  changeLanguage(type: string) {
    this.homeService.changeLanguage(type).then((response) => {
      window.location.reload();
    });
  }

  postClockAction($event: any, ignoreLocation: boolean) {
    $event.preventDefault();
    $event.stopPropagation();
    this.performingClockAction = true;
    this.requestObj = {};

    if (this.clockInUsePhase && !this.clockStatus.ClockAction) {
      const initialState = {
        portalSettings: this.portalSettings,
        employeeInfo: this.employeeInfo,
        backdrop: 'static'
      };

      let modalRef = this.modalService.show(ClockinJobModalComponent, { initialState, ignoreBackdropClick: true, keyboard: true });

      modalRef.onHide.subscribe((reason: any) => {
        var result = modalRef.content;
        if (result.userAction == "cancel") {
          this.performingClockAction = false;
        } else {
          if (result != null && result.userAction == "Clock In") {
            if (!ignoreLocation && this.position != null && this.position.coords != null) {
              this.requestObj.gPSLat = this.position.coords.latitude;
              this.requestObj.gPSLong = this.position.coords.longitude;
            }
            if (result.formData.selectedJob != null) {
              this.requestObj.jCJMKeyID = result.formData.selectedJob.JCJMKeyID;
            }
            if (result.formData.selectedPhase != null) {
              this.requestObj.jCJPKeyID = result.formData.selectedPhase.JCJPKeyID;
            }
            var currentTime = moment();
            this.requestObj.clockTimeString = currentTime.format("MM/DD/YYYY h:mm:ss a");
            this.homeService.postClockAction(this.requestObj).then((response: any) => {
              if (response.success) {
                this.getClockInStatus();
              }
              else {
                this.performingClockAction = false;
                const initialState = {
                  modalData: { modalTitle: "An Error Ocurred", modalMessage: response.error },
                  backdrop: 'static'
                }
                let modalRef = this.modalService.show(ErrorModalComponent, { initialState, ignoreBackdropClick: true, keyboard: true });
              }
            });
          }
          else {
            this.performingClockAction = false;
          }
        }
      });
    }
    else {
      if (this.portalSettings.RequireSignClockOut.ConfigValue == "1" && this.clockStatus.ClockAction) {
        const initialState = {
          portalSettings: this.portalSettings,
          employeeInfo: this.employeeInfo,
          backdrop: 'static'
        };

        let modalRef = this.modalService.show(ClockoutModalComponent, { initialState, ignoreBackdropClick: true, keyboard: true });

        modalRef.onHide.subscribe((reason: any) => {
          var result = modalRef.content.userAction;
          if (result == "close") {
            this.performingClockAction = false;
          } else {
            if (!ignoreLocation && this.position != null && this.position.coords != null) {
              this.requestObj.gPSLat = this.position.coords.latitude;
              this.requestObj.gPSLong = this.position.coords.longitude;
            }
            this.requestObj.signatureData = result;
            var currentTime = moment();
            this.requestObj.clockTimeString = currentTime.format("MM/DD/YYYY h:mm:ss a");
            this.homeService.postClockAction(this.requestObj).then((response: any) => {
              if (response.success) {
                this.getClockInStatus();
              }
              else {
                this.performingClockAction = false;
                const initialState = {
                  modalData: { modalTitle: "An Error Ocurred", modalMessage: response.error },
                  backdrop: 'static'
                }
                let modalRef = this.modalService.show(ErrorModalComponent, { initialState, ignoreBackdropClick: true, keyboard: true });
              }
            });
          }
        });
      } else {
        if (!ignoreLocation && this.position != null && this.position.coords != null) {
          this.requestObj.gPSLat = this.position.coords.latitude;
          this.requestObj.gPSLong = this.position.coords.longitude;
        }
        var currentTime = moment();
        this.requestObj.clockTimeString = currentTime.format("MM/DD/YYYY h:mm:ss a");
        this.homeService.postClockAction(this.requestObj).then((response: any) => {
          if (response.success) {
            this.getClockInStatus();
          }
          else {
            this.performingClockAction = false;
            const initialState = {
              modalData: { modalTitle: "An Error Ocurred", modalMessage: response.error },
              backdrop: 'static'
            }
            let modalRef = this.modalService.show(ErrorModalComponent, { initialState, ignoreBackdropClick: true, keyboard: true });
          }
        });
      }
    }
  }

  unbindViewpointID() {
    const initialState = {
      portalSettings: this.portalSettings,
      employeeInfo: this.employeeInfo,
      modalData: { modalTitle: "Unlink Viewpoint ID", modalMessage: "Are you sure you want to unbind your Keystyle account from your Viewpoint account?", modalAction: "Unbind", closeButtonText: "Cancel", warningLevel: "primary" },
      backdrop: 'static'
    };

    let modalRef = this.modalService.show(WarningModalComponent, { initialState, ignoreBackdropClick: true, keyboard: true });

    modalRef.onHide.subscribe((reason: any) => {
      var result = modalRef.content.userAction;
      if (result == "Unbind") {
        this.homeService.unbindViewpointID().then((response: any) => {
          if (response.success) {
            //this.alert = { type: "success", msg: "Email reminder sent" }; --Unused alert
            const initialState = {
              portalSettings: this.portalSettings,
              employeeInfo: this.employeeInfo,
              modalData: { modalTitle: "Unlink Viewpoint ID", modalMessage: "Keystyle account unbound from Viewpoint ID successfully.", closeButtonText: "Close", alertLevel: "success" },
              backdrop: 'static'
            };
            let modalRef = this.modalService.show(AlertModalComponent, { initialState, ignoreBackdropClick: true, keyboard: true });
          } else {
            const initialState = {
              portalSettings: this.portalSettings,
              employeeInfo: this.employeeInfo,
              modalData: { modalTitle: "Unlink Viewpoint ID", modalMessage: response.error, closeButtonText: "Close", alertLevel: "danger" },
              backdrop: 'static'
            };
            let modalRef = this.modalService.show(AlertModalComponent, { initialState, ignoreBackdropClick: true, keyboard: true });
          }
        });
      }
    });
  }

  getClockInStatus() {
    var currentTime = moment();
    var currentTimeString = currentTime.format("MM/DD/YYYY h:mm:ss a");
    this.homeService.getClockInStatus(false, currentTimeString).then((response) => {
      if (response != null) {
        this.performingClockAction = false;
        this.clockStatus = response;
        this.getLocation();
        if (this.clockStatus.ClockTime != null) {
          this.clockStatus.ClockTimeDisplay = moment(parseInt(this.clockStatus.ClockTime.substring(6))).utc().format(this.format.toUpperCase() + " hh:mm a");
        }
      }
    }).catch((error) => {
      this.performingClockAction = false;
      this.errorMsg = error?.error?.error ?? "An error has occured";
    });
  }

  getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        this.requestingLocation = false;
        this.geolocationEnabled = true;
        this.position = position;
      });
    }
    else {
      this.requestingLocation = false;
    }
  }

  subStringFromComma(text: string) {
    var temp = text.split(',');
    return temp[1];
  }

  closeMenusSection(number: any, type: any) {
    if (number != null && this.menu[number]) {
      this.menu[number] = false;
      return;
    }
    else if (type === 'h' && !number && this.hotlistMenu) {
      this.hotlistMenu = false;
      return;
    }
    else if (type === 't' && !number && this.teamMenu) {
      this.teamMenu = false;
      return;
    }
    else if (type === 'n' && !number && this.userNameMenu) {
      this.userNameMenu = false;
      return;
    }
    else {
      for (var i = 0; i < this.moduleCategories?.length; i++) {
        this.menu[i] = false;
      }
      this.hotlistMenu = false;
      this.userNameMenu = false;
      this.teamMenu = false;

      if (number != null) {
        this.menu[number] = true;
      }
      if (type === 'h' && !number) {
        this.hotlistMenu = true;
      }
      if (type === 't' && !number) {
        this.teamMenu = true;
      }
      if (type === 'n' && !number) {
        this.userNameMenu = true;
      }
    }
  }

  logout() {
    sessionStorage.clear();
    window.location.href = "/Account/Logout";
  }

  openModal() {
    document.getElementById('fadeNav').style.display = 'block';
  }

  closeModal() {
    document.getElementById('fadeNav').style.display = 'none';
  }

  //approvedTimecardsChanged  &  approvedDependentChanged
  getEmployeeInfo() {
    this.homeService.getEmployeeInfo().then((response: any[]) => {
      this.employeeInfo = response;
      this.calculateUnapprovedRequestCount()
    });
  }

  //approvedTimeoffChanged
  modifyApprovedTimeOff() {
    this.employeeInfo.TimeOffCount--;
    if (this.employeeInfo.TimeOffCount < 0) {
      this.employeeInfo.TimeOffCount = 0;
    }
    this.calculateUnapprovedRequestCount()
  }

  //approvedBenefitMinus
  subtractApprovedBenefit() {
    this.homeService.getCount().then((response: any) => {
      this.employeeInfo.UnapprovedBenefitRequestCount = response[0];

      this.calculateUnapprovedRequestCount()
    })
  }

  //productionApprovalChanged
  modifyProductionApproval(count: number) {
    this.employeeInfo.ProgressApprovalCount = count > 0 ? count : 0;

    this.calculateUnapprovedRequestCount()
  }

  closeGlobalNav() {
    document.getElementById("globalSideNav").style.width = "0";
    this.closeMenusSection(null, null);
  }
}